import React from 'react';

import ButtonDefault from '@src/Components/Atoms/ButtonDefault/ButtonDefault';
import { CloseIcon } from '@src/Components/Icons/CloseIcon/CloseIcon';

import DefaultModal from '../DefaultModal/DefaultModal';
import styles from './ModalMessage.module.scss';

export interface IModalMessage {
  show: boolean;
  headerTitle: string;
  message: string;
  buttonTitle: string;
  onClose?: () => void;
  onClick?: () => void;
}

const ModalMessage: React.FC<IModalMessage> = ({
  show,
  onClose,
  headerTitle,
  message,
  buttonTitle,
  onClick
}) => {
  return (
    <>
      <DefaultModal
        onClose={onClose}
        show={show}
        isBackgroundContainers={true}
        backgroundContent="transparent"
      >
        <section data-testid="modal-message" className={styles['Container']}>
          <header className={styles['Header']}>
            <h4>{headerTitle}</h4>
            {onClose && (
              <button onClick={onClose}>
                <CloseIcon height={18} width={18} />
              </button>
            )}
          </header>
          <main className={styles['Content']}>
            <p>{message}</p>
            <ButtonDefault label={buttonTitle} onClick={onClick} />
          </main>
        </section>
      </DefaultModal>
    </>
  );
};

export default ModalMessage;
